import axios from 'axios';
import {apiService} from "./api.service";
import {convertToPageable, extractData, handleApiException, handleResponse} from "../helpers/apiResponseHelper";

async function getFeatures(pageRequest?: any) {
    return axios.get(apiService.getApiUrl() + '/station-features',
        {
            params: pageRequest,
        }).then(handleResponse).then(convertToPageable);
}
async function getStations(pageRequest?: any) {
    return axios.get(apiService.getApiUrl() + '/petrol-stations',
        {
            params: pageRequest,
        }).then(handleResponse).then(convertToPageable);
}

async function getStationsWithCardDistribution() {
    return axios.get(apiService.getApiUrl() + '/petrol-stations/card-distribution')
        .then(handleResponse).then(extractData);
}

async function getCustomerStations(customerId: number, pageRequest?: any) {
    return axios.get(apiService.getApiUrl() + '/petrol-stations/' + customerId,
        {
            params: pageRequest
        }).then(handleResponse).then(extractData).catch(handleApiException);
}

async function getSummerGamePetrolStations(userId: number) {
    return axios.get(apiService.getApiUrl() + '/petrol-stations/summer-game/' + userId)
        .then(handleResponse)
        .then(extractData)
        .catch(handleApiException);
}

const PetrolStationService = {
    getFeatures,
    getStations,
    getCustomerStations,
    getSummerGamePetrolStations,
    getStationsWithCardDistribution
};

export default PetrolStationService;
